// The output of import { schemeGnBu } from "d3";
// To avoid having to load the full d3 just for an array and since we only use the
// last index, we only keep that one
import { Annotation } from "../api";
import { FEATURE_FLAGS } from "../pages/_app";

export const schemeGnBu = [
  "#f7fcf0",
  "#e0f3db",
  "#ccebc5",
  "#a8ddb5",
  "#7bccc4",
  "#4eb3d3",
  "#2b8cbe",
  "#0868ac",
  "#084081",
];

export function pickViralRectColor(annotation: Annotation): string {
  if (!annotation.gene || annotation.gene.product === "hypothetical protein") {
    return "lightgray";
  }
  switch (annotation.gene.gene_type) {
    case "3'UTR":
      return schemeGnBu[1];
    case "5'UTR":
      return schemeGnBu[3];
    case "CDS":
      return schemeGnBu[5];
    case "mat peptide":
      return schemeGnBu[7];
    case "EC7 Translocases":
      return schemeGnBu[8];
  }

  if (annotation.gene.gene_type !== "CDS") {
    return "dimgray";
  }

  if (annotation.gene.ec_number) {
    return schemeGnBu[parseInt(annotation.gene.ec_number.split(".")[0], 10)];
  }

  return "dimgray";
}

export function pickRectColor(annotation: Annotation): string {
  if (!annotation.gene || annotation.gene.product === "hypothetical protein") {
    return "lightgray";
  }

  if (
    (FEATURE_FLAGS.AmrSources && annotation.amr_sources.length > 0) ||
    (!FEATURE_FLAGS.AmrSources && annotation.gene && annotation.gene.is_amr)
  ) {
    // this color is called "bumblebee"
    return "#fce205";
  }

  if (annotation.gene.gene_type !== "CDS") {
    return "firebrick";
  }

  if (annotation.gene.ec_number) {
    return schemeGnBu[parseInt(annotation.gene.ec_number.split(".")[0], 10)];
  }

  return "dimgray";
}

// 0 is the default colour
export function pickSearchResultColor(nth: number): string {
  const atcc = [
    "#cbd8e9",
    "#f8e08e",
    "#b7dd79",
    "#6eceb2",
    "#009fdf",
    "#b8381a",
    "#e6674a",
    "#ffc658",
  ];
  return atcc[nth];
}
